import { Stage } from 'lbs-pi-webgl-renderer-dev';
import { TileLayer } from './TileLayer';
import { BackgroundLayer } from './BackgroundLayer';

export class TileStage extends Stage {
  renderer;
  viewport;
  vpState;
  backgroundLayer;
  layers;

  // TODO: Rename 'cameraRect' to 'screenRect' -- naming consistency between classes
  constructor (viewport, requestQueue, cameraRect) {
    super();
    this.viewport = viewport;
    this.pyramid = viewport.getPyramid();
    this.vpState = viewport.getVPView();
    this.requestQueue = requestQueue;
    this.backgroundLayer = new BackgroundLayer(this.viewport, requestQueue);
    this.layers = new Map(); // tile layers
    this.cameraRect = cameraRect;
  }

  resize (width, height) {
    this.layers.forEach((layer) => layer.resize(width, height));
  }

  // interface members
  init () {
    this.backgroundLayer.init();
    // create one layer to render each pyramid level
    const pyramid = this.viewport.getPyramid();
    pyramid.forEach((level) => {
      const layer = new TileLayer(level, this.viewport, this.requestQueue);
      layer.attachRenderer(this.renderer);
      this.layers.set(level.zoom, layer);
    });
  }

  attachRenderer (renderer) {
    this.renderer = renderer;
    this.backgroundLayer.attachRenderer(renderer);
  }

  update () {
    this.backgroundLayer.update(this.vpState);

    const activePyramidLevel = this.pyramid.getNearestZoom(this.vpState.zoom);
    this.layers.forEach((layer) => {
      layer.update(this.vpState, activePyramidLevel === layer.pyramidZoom, this.cameraRect);
    });
  }

  draw (renderer) {
    this.backgroundLayer.draw(renderer.camera);
    this.layers.forEach((l) => {
      l.draw(renderer.camera);
    });
  }
}
